/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-cool': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 15a5 5 0 004.281-2.431l-1.069-.625a3.75 3.75 0 01-6.425 0l-1.068.625A5 5 0 0010 15zm0-13.75a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 1.25a7.5 7.5 0 016.806 4.375h-1.181A.625.625 0 0015 6.25H5a.625.625 0 00-.625.625H3.194A7.5 7.5 0 0110 2.5zm0 15A7.5 7.5 0 012.5 10a7.413 7.413 0 01.25-1.875h1.625v1.25c0 .69.56 1.25 1.25 1.25h2.069a1.25 1.25 0 001.25-1.044L9.269 7.5h1.462l.344 2.081a1.25 1.25 0 001.25 1.044h2.05c.69 0 1.25-.56 1.25-1.25v-1.25h1.625c.163.612.247 1.242.25 1.875a7.5 7.5 0 01-7.5 7.5z"/>'
  }
})
